import type { Lucid } from '../../types/types';

type PageTypes = 'product-template' | 'product-template-hub' | 'product-template-category' | 'help-center';

type WithCustomPaths = (
  shortCode: Lucid.I18n.LanguagesShortCode,
  product: Lucid.Site.Product,
  type: PageTypes,
) => Lucid.Generic.RelativeURL;

const productTemplateHubPaths: Record<Lucid.I18n.LanguagesShortCode, Lucid.Generic.RelativeURL> = {
  da: '/templates',
  de: '/vorlagen',
  en: '/templates',
  es: '/plantillas',
  fr: '/modeles',
  it: '/modelli',
  ja: '/templates',
  nl: '/sjablonen',
  pt: '/modelos',
  ru: '/templates',
  sv: '/templates',
  ko: '/templates',
  pl: '/templates',
};

const helpCenterPaths: Record<Lucid.I18n.LanguagesShortCode, Lucid.Generic.RelativeURL> = {
  da: '/hc/de',
  de: '/hc/de',
  en: '/hc/en-us',
  es: '/hc/es-419',
  fr: '/hc/fr',
  it: '/hc/it',
  ja: '/hc/ja',
  nl: '/hc/nl',
  pt: '/hc/pt',
  ru: '/hc/ru',
  sv: '/hc/sv',
  ko: '/hc/ko',
  pl: '/hc/pl',
};

const withCustomPaths: WithCustomPaths = (shortCode, product, type) => {
  if (product === 'edu') return '/assignments';

  switch (type) {
    case 'product-template':
    case 'product-template-hub':
    case 'product-template-category':
      return productTemplateHubPaths[shortCode];

    case 'help-center':
      return helpCenterPaths[shortCode];

    default:
      return '/';
  }
};

export default withCustomPaths;
